module.exports = __webpack_public_path__ + "static/media/expert3.72faec2c.png";